export default "__VITE_ASSET__ae40295f__"